import { floatAddition } from '@/utils/FloatNumber'
import Script from 'next/script'
import { FC, useCallback } from 'react'

/* Init Taboola Script */
export const TaboolaScript: FC = () => {
  return (
    <Script id='taboola-script'>{`window._tfa = window._tfa || []; window._tfa.push({notify: 'event', name: 'page_view', id: 1499883}); !function (t, f, a, x) { if (!document.getElementById(x)) { t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f); } }(document.createElement('script'), document.getElementsByTagName('script')[0], '//cdn.taboola.com/libtrc/unip/1499883/tfa.js', 'tb_tfa_script');`}</Script>
  )
}

/* Taboola Tracking Event Log */
export const useTaboola = () => {
  return useCallback((eventName: string, data: Record<string, any>) => {
    if (typeof window?.['_tfa']?.push != 'undefined') {
      switch (eventName) {
        case 'make_purchase':
          window?.['_tfa'].push({
            notify: 'event',
            name: eventName,
            id: 1499883,
            revenue: floatAddition(floatAddition(data?.grand_total, data?.use_balance_amount), data?.use_wallet_amount),
            currency: 'GBP',
            orderid: data?.id,
          })
          break

        case 'register':
          // TODO
          break

        default:
          break
      }
    }
  }, [])
}

export default TaboolaScript
